module.exports = __webpack_public_path__ + "img/how_it_works_banner.79036fad.png";